
import { Locker, LockerResponse, PointLocation } from '../data/LockerDataTypes';
import { TrackedAction } from '../data/Tracking';
import { API_BASE_URL } from '../Settings';
import { FilterRequest } from './filterAssistent';

export class Api {
    private static api: Api;
    private constructor() { }

    public static Get = (): Api => {
        if (!Api.api) {
            Api.api = new Api();
        }
        return Api.api;
    }

    public GetMapCenterCoordinates = async (cityName: string, countyName: string, countryCode: string): Promise<PointLocation> => {
        if (cityName || countyName) {
            const response = await fetch(`${API_BASE_URL}/api/City/GetMapCenterCoordinates?cityName=${cityName}&countyName=${countyName}&countryCode=${countryCode}`);
            if (response.ok) {
                const data = await response.json();
                return data as unknown as PointLocation;
            }
        }
        console.error('cannot fetch initial location')
        return Promise.resolve(this.GetCapitalCenterPoint(countryCode));
    }

    public IsHostValid = async (clientId: string, host: string): Promise<boolean> => {
        if (clientId) {
            const response = await fetch(`${API_BASE_URL}/api/Client/${clientId}/IsHostValid?host=${host}`);

            if (response.status && response.status == 200) {
                const data = await response.json();
                return data as unknown as boolean;
            }
        }

        console.error('could not validate host')
        return Promise.resolve(false);
    }

    public HasFavouriteLockerEnabled = async (clientId: string): Promise<boolean> => {
        const response = await fetch(`${API_BASE_URL}/api/Client/${clientId}/HasFavouriteLockerEnabled`);
        if (response.status && response.status == 200) {
            const data = await response.json();
            return data as unknown as boolean;
        }

        console.error('could not check if hasFavouriteLockerEnabled')
        return Promise.resolve(false);
    }

    public GetLockers = async (filter?: FilterRequest<Locker>): Promise<LockerResponse | null> => {
        let filterQuery = "";
        if (filter) {
            filterQuery = filter?.GenerateQueryFilter();
        }
        const response = await fetch(`${API_BASE_URL}/api/Locker${filterQuery}`);
        if (response.ok) {
            const data = await response.json();
            return data as unknown as LockerResponse;
        }
        console.error("cannot fetch lockers");
        return Promise.resolve(null);
    }

    public GetLockersInArea = async (ne: PointLocation, sw: PointLocation, countryCode: string): Promise<Locker[]> => {
        const response = await fetch(`${API_BASE_URL}/api/Locker/InArea?neLat=${ne.lat}&neLng=${ne.lng}&swLat=${sw.lat}&swLng=${sw.lng}&countryCode=${countryCode}`);

        if (response.ok) {
            const data = await response.json();
            return data as Locker[];
        }
        console.error("cannot fetch lockersInArea");
        return [];
    }

    public SearchLockers = async (filter: string, countryCode: string): Promise<Locker[]> => {
        const response = await fetch(`${API_BASE_URL}/api/Locker/Search?SearchFilter=${filter}&countryCode=${countryCode}`);

        if (response.ok) {
            const data = await response.json();
            return data as Locker[];
        }
        console.error("cannot fetch Locker/Search");
        return [] as Locker[];
    }

    public SaveTrackedAction = async (trackedAction: TrackedAction): Promise<void> => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(trackedAction)
        };

        await fetch(`${API_BASE_URL}/api/TrackedAction/`, requestOptions);
    }

    public GetCapitalCenterPoint = (countryCode: string): PointLocation => {
        const RO = { lat: 44.43008, lng: 26.10205 } as PointLocation;
        const HU = { lat: 47.4979, lng: 19.0402 } as PointLocation;
        const BG = { lat: 42.698334, lng: 23.319941 } as PointLocation;

        switch (countryCode) {
            case "HU": return HU;
            case "BG": return BG;
            default: return RO;
        }
    }

    public ValidateRecaptchaToken = async (token: string | null): Promise<boolean> =>{
        
        const response = await fetch(`${API_BASE_URL}/api/Recaptcha/IsValid?token=${token}`);
        if (response.status && response.status == 200) {
            var data = await response.json();
            return data as unknown as boolean;
        }

        console.error('could not validate recaptcha token')
        return Promise.resolve(false);
        
    }
}
